import { lang } from '@umu/ukit-lang';
/**
 * @description logo
 * @author duanjun
 */

import React, { Component, PropsWithChildren } from 'react';
import { $window, classSet } from '@umu/umu-dom';
import './toggleLine.scss';

type ThemeType = '1' | '2' | '3';

interface IMaskHelpProps {
    maxLine: number;
    lineHeight: number;
    theme: ThemeType;
    labelClosed: string;
    showArrowInTheme3: boolean;
}

class MaskHelp extends Component<IMaskHelpProps> {
    public static defaultProps = {
        maxLine: 2,
        lineHeight: 0,
        theme: '1',
        labelClosed: '',
        showArrowInTheme3: false,
    };

    constructor(props: IMaskHelpProps) {
        super(props);
    }

    public renderTheme3() {
        const afterClass = classSet({
            after: true,
            showArrow: !!this.props.showArrowInTheme3,
        });
        return (
            <span className="maskHelp">
                <span
                    className="before"
                    style={{
                        height: (this.props.maxLine - 1) * this.props.lineHeight,
                    }}
                ></span>
                <span
                    className={afterClass}
                    style={{
                        height: this.props.lineHeight + 'px',
                        // tslint:disable-next-line:max-line-length
                        marginBottom: (this.props.theme === '3' ? 1 - this.props.lineHeight : 0) + 'px',
                    }}
                >
                    {lang('展开')}
                </span>
            </span>
        );
    }

    public renderTheme12() {
        return (
            <span className="maskHelp">
                {this.props.theme === '2' ? <span className="label">{this.props.labelClosed}</span> : ''}
                <span
                    className="before"
                    style={{
                        height: (this.props.maxLine - 1) * this.props.lineHeight,
                    }}
                ></span>
                <span
                    className="after"
                    style={{
                        height: this.props.lineHeight + 'px',
                        // tslint:disable-next-line:max-line-length
                        marginBottom:
                            (this.props.theme === '1' || this.props.theme === '3' ? 1 - this.props.lineHeight : 0) +
                            'px',
                    }}
                ></span>
            </span>
        );
    }

    public render() {
        if (this.props.theme === '3') {
            return this.renderTheme3();
        }
        return this.renderTheme12();
    }
}

interface IShowMoreProps {
    maxLine: number;
    lineHeight: number;
    theme: ThemeType;
    labelOpen: string;
    showArrowInTheme3: boolean;
}

class ShowMore extends Component<IShowMoreProps> {
    public static defaultProps = {
        maxLine: 2,
        lineHeight: 0,
        theme: '1',
        labelOpen: '',
        showArrowInTheme3: false,
    };

    constructor(props: IShowMoreProps) {
        super(props);
    }

    public renderTheme3() {
        const afterClass = classSet({
            after: true,
            showArrow: !!this.props.showArrowInTheme3,
        });
        return (
            <span className="showMore">
                <span className="label">{this.props.labelOpen}</span>
                <span className="before">{lang('展开')}</span>
                <span className={afterClass} style={{ height: this.props.lineHeight + 'px' }}>
                    {lang('收起')}
                </span>
            </span>
        );
    }

    public renderTheme12() {
        return (
            <span className="showMore">
                {this.props.theme === '2' ? <span className="label">{this.props.labelOpen}</span> : ''}
                <span className="before"></span>
                <span className="after" style={{ height: this.props.lineHeight + 'px' }}></span>
            </span>
        );
    }

    public render() {
        if (this.props.theme === '3') {
            return this.renderTheme3();
        }
        return this.renderTheme12();
    }
}

interface IToggleLineProps extends PropsWithChildren<{}> {
    className?: string;
    maxLine: number;
    theme: ThemeType;
    labelOpen: string;
    labelClosed: string;
    text: string;
    expandByBtn: boolean; // 是否只点击按钮才进行展开
    onBeforeClick?: () => boolean;
    showArrowInTheme3?: boolean;
}

interface IToggleLineState {
    height: number;
    lineHeight: number;
    single: boolean;
    active: boolean;
}

export default class ToggleLine extends Component<IToggleLineProps, IToggleLineState> {
    public static defaultProps = {
        className: '',
        maxLine: 2,
        theme: 1,
        labelOpen: '',
        labelClosed: '',
        text: '',
        expandByBtn: false,
        showArrowInTheme3: false,
    };

    private toggleCnt: HTMLDivElement | undefined;
    private timer: number = 0;

    constructor(props: IToggleLineProps) {
        super(props);
        this.state = {
            height: 0,
            lineHeight: 0,
            single: true,
            active: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.checkHeight = this.checkHeight.bind(this);
    }

    public componentDidUpdate() {
        // this.checkHeight(); // TODO
        clearTimeout(this.timer);
        this.timer = $window.setTimeout(this.checkHeight, 500);
    }

    public componentDidMount() {
        this.checkHeight();
    }

    public componentWillUnmount() {
        clearTimeout(this.timer);
    }

    public checkHeight() {
        const cntEl = this.toggleCnt;
        if (!cntEl) {
            return;
        }

        const style = $window.getComputedStyle(cntEl);
        const key = 'line-height' as keyof CSSStyleDeclaration;
        let lineHeight = style[key];
        if (!lineHeight) {
            return;
        }
        // @ts-ignore
        lineHeight = lineHeight.split('px')[0];
        if (lineHeight === 'nomal') {
            lineHeight = '24';
        }
        const height = cntEl.getBoundingClientRect().height;
        if (height !== this.state.height || lineHeight !== this.state.lineHeight) {
            this.setState({
                height,
                // @ts-ignore
                lineHeight,
                // @ts-ignore
                single: height <= this.props.maxLine * lineHeight + 1,
            });
        }
    }

    public handleClick(event: React.MouseEvent<HTMLSpanElement>, isFromBtn?: boolean) {
        if (this.props.onBeforeClick && !this.props.onBeforeClick()) {
            return;
        }
        if (isFromBtn) {
            event.stopPropagation();
        }
        if (this.state.single || (this.props.expandByBtn && !isFromBtn)) {
            return;
        }

        this.setState({
            active: !this.state.active,
        });
    }

    public render() {
        const text = this.props.text;
        const maskHelp = (
            <MaskHelp
                showArrowInTheme3={this.props.showArrowInTheme3}
                theme={this.props.theme}
                labelClosed={this.props.labelClosed}
                maxLine={this.props.maxLine}
                lineHeight={this.state.lineHeight}
            />
        );
        const showMore = (
            <ShowMore
                showArrowInTheme3={this.props.showArrowInTheme3}
                theme={this.props.theme}
                labelOpen={this.props.labelOpen}
                maxLine={this.props.maxLine}
                lineHeight={this.state.lineHeight}
            />
        );
        return (
            <div
                onClick={(e) => this.handleClick(e)}
                style={{
                    WebkitLineClamp:
                        this.props.theme === '1' || this.props.theme === '3' ? this.props.maxLine : 'initial',
                }}
                className={
                    'toggleLine' +
                    ' ' +
                    this.props.className +
                    ' ' +
                    'theme' +
                    this.props.theme +
                    ' ' +
                    (this.state.single ? 'single' : '') +
                    ' ' +
                    (this.state.active ? 'active' : '') +
                    ' '
                }
            >
                <span onClick={(e) => this.handleClick(e, true)}>
                    {(!this.state.single && this.props.theme === '1') || this.props.theme === '3' ? maskHelp : null}
                </span>
                <span
                    className="toggleLineWrap"
                    style={{ WebkitLineClamp: this.props.theme === '2' ? this.props.maxLine : 'initial' }}
                >
                    <span
                        className="toggleCnt"
                        ref={(ref) => {
                            this.toggleCnt = ref as HTMLDivElement;
                        }}
                    >
                        {text || this.props.children}
                    </span>
                </span>
                <span onClick={(e) => this.handleClick(e, true)}>
                    {!this.state.single && this.props.theme === '2' ? maskHelp : null}
                    {!this.state.single ? showMore : null}
                </span>
            </div>
        );
    }
}

ToggleLine.defaultProps = {
    className: '',
    maxLine: 2,
    theme: 1,
    labelOpen: '',
    labelClosed: '',
    text: '',
    expandByBtn: false, // 是否只点击按钮才进行展开
    showArrowInTheme3: false,
};
